import Link from "next/link";
import React from "react";

import BookAppointmentButton from "@/components/utilities/BookAppointmentButton";

export interface SoftCTASectionProps {
  heading?: string;
  subheading?: string;
  ctaLabel?: string;
  ctaLink?: string;
}

/**
 * Soft Consultation CTA Section
 * Catches ready but cautious users at the bottom
 */
export default function SoftCTASection({
  heading = "Not Sure Which Treatment Is Right for You?",
  subheading = "Start with a doctor-led consultation to understand your options based on medical evaluation.",
  ctaLabel = "Request Consultation",
  ctaLink = "/appointment",
}: SoftCTASectionProps) {
  return (
    <section className="bg-violet-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="rounded-3xl bg-gradient-to-r from-purple-600 to-pink-600 p-8 text-center text-white shadow-lg md:p-10">
          <h2 className="text-2xl font-bold md:text-3xl">{heading}</h2>
          <p className="mt-2 text-sm text-white/90 md:text-base">
            {subheading}
          </p>

          {ctaLabel && ctaLink && (
            <div className="mt-6 flex justify-center">
              <Link
                href={ctaLink}
                className="inline-flex items-center rounded-xl bg-white px-6 py-3 text-sm font-semibold text-violet-950 transition hover:bg-violet-100 md:text-base"
              >
                {ctaLabel}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
